
import {postUpdateTournament} from '../api/postUpdateTournament';

const setPostUpdateTournament = (params) => {
    return async (dispatch, getState) => {
        try {
            await postUpdateTournament(params);
        } catch(error) {
            if (error && error.response && error.response.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}

export {
    setPostUpdateTournament
}